<template>
  <div
    class="content"
    :style="
      extraItem.extras('activityTheme.display') == 1 ||
      extraItem.extras('activityTime.display') == 1 ||
      extraItem.extras('activityPlace.display') == 1 ||
      extraItem.extras('activitySchedule.display') == 1 ||
      platform == 'wap'
        ? ''
        : 'width:80%'
    "
  >
    <div
      class="u-success"
      :style="{
        display: extraItem.extras('refuseImg.display') == 0 ? 'none' : 'block',
      }"
    >
      <img :src="extraItem.extras('refuseImg.src')" alt="" />
    </div>
    <div
      class="t-success"
      :style="{
        color: extraItem.extras('refuseTitle.color'),
        fontSize: pxOrVw(extraItem.extras('refuseTitle.size')),
        fontWeight:
          extraItem.extras('refuseTitle.weight') == 'default'
            ? '500'
            : extraItem.extras('refuseTitle.weight'),
        display:
          extraItem.extras('refuseTitle.display') == 0 ? 'none' : 'block',
      }"
    >
      {{ extras | extra("refuseTitle.model") }}
    </div>
    <div
      class="t-success-desc"
      :style="{
        color: extraItem.extras('refuseText.color'),
        fontSize: pxOrVw(extraItem.extras('refuseText.size')),
        fontWeight:
          extraItem.extras('refuseText.weight') == 'default'
            ? '400'
            : extraItem.extras('refuseText.weight'),
        display: extraItem.extras('refuseText.display') == 0 ? 'none' : 'block',
      }"
    >
      {{ extras | extra("refuseText.model") }}
    </div>
  </div>
</template>
<script>
export default {
  name: "RefuseCon",
  props: ["platform"],
  computed: {
    extras() {
      return this.$store.state.extras;
    },
  },
};
</script>
